/* eslint-disable */
/* eslint-disable vue/no-v-html */
import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueCrontab from 'vue-crontab'
import moment from 'moment-timezone'
import IdleVue from 'idle-vue'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)


Vue.component('apexchart', VueApexCharts)
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'

//import material-icon scss
import "font-awesome/css/font-awesome.min.css";

//defined as global component
Vue.component('VueFontawesome', require('vue-fontawesome-icon/VueFontawesome.vue').default);


// BSV Plugin Registration





const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 60 * 1000 * 30, // 3 seconds
  startAtIdle: false
});
Vue.use(ToastPlugin)

Vue.use(ModalPlugin)

// 3rd party 
Vue.use(VueCrontab)
Vue.use(require('vue-moment'), {
    moment,
})

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')